import { render, staticRenderFns } from "./MstRegistriesEditor.vue?vue&type=template&id=40d74e8f&scoped=true&"
import script from "./MstRegistriesEditor.vue?vue&type=script&lang=ts&"
export * from "./MstRegistriesEditor.vue?vue&type=script&lang=ts&"
import style0 from "./MstRegistriesEditor.vue?vue&type=style&index=0&id=40d74e8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d74e8f",
  null
  
)

export default component.exports